import React, { FC, ReactNode, useState } from "react";
import { Theme } from "evcharging/app/themes";
import { css } from "@emotion/css";
import useTheme from "evcharging/hooks/useTheme";
import RatesQuestionIcon from "components/icons/RatesQuestionIcon";

interface RatesTooltipProps {
  children: ReactNode;
}

const RatesTooltip: FC<RatesTooltipProps> = (props) => {
  const { children } = props;
  const theme = useTheme();
  const classes = createStyles(theme);

  const [show, setShow] = useState<boolean>(false);

  const onClick = () => {
    setShow(!show);
  };

  return (
    <span className={classes.infoIcon}>
      <button onClick={onClick}>
        <RatesQuestionIcon />
      </button>
      {show && <div className={classes.tooltip}>{children}</div>}
    </span>
  );
};

const createStyles = (theme: Theme) => ({
  infoIcon: css({
    display: "block",
    marginTop: 5,
    marginLeft: 5,
    cursor: "pointer",
    "& > button": {
      border: "none",
      background: "none",
      padding: 0
    }
  }),
  tooltip: css({
    position: "absolute",
    bottom: "100%",
    left: 0,
    background: "#000",
    color: "#fff",
    width: 250,
    padding: 8,
    borderRadius: 4
  })
});


export default RatesTooltip;